import {Modal} from "@mui/material"
import React, {useState} from "react"
import {makeStyles} from "tss-react/mui"

interface LegacyExpandedDesignProps {
	renderUrl: string
}

const useStyles = makeStyles()({
	previewContainer: {
		cursor: "pointer",
		minHeight: "300px",
		display: "flex",
		alignItems: "center",
	},
	previewImage: {
		borderTop: "2px solid whitesmoke",
		borderBottom: "2px solid whitesmoke",
	},
	modal: {
		position: "absolute",
		top: "50%",
		right: "50%",
		transform: "translate(50%,-50%)",
		border: "0px",
		outline: "none",
		width: "90%",
		height: "90%",
	},
	modalImage: {
		maxWidth: "100%",
		maxHeight: "100%",
		width: "auto",
		height: "auto",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		margin: "auto",
		position: "absolute",
	},
})

export default function LegacyExpandedDesign(props: LegacyExpandedDesignProps) {
	const {classes} = useStyles()

	const [open, setOpen] = useState(false)

	function handleOpen() {
		setOpen(true)
	}

	function handleClose() {
		setOpen(false)
	}
	return (
		<div>
			<div className={classes.previewContainer}>
				<img
					className={classes.previewImage}
					src={getMiniPreviewUrl(props.renderUrl)}
					style={{width: "300px", height: "300px"}}
					alt={""}
					onClick={handleOpen}
				></img>
			</div>
			<Modal open={open} onClose={handleClose} onClick={handleClose}>
				<div className={classes.modal}>
					<img
						className={classes.modalImage}
						style={{maxWidth: "3000px", maxHeight: "3000px"}}
						src={getPreviewUrl(props.renderUrl)}
						alt=""
					/>
				</div>
			</Modal>
		</div>
	)
}

function getPreviewUrl(url: string): string {
	return url
}

function getMiniPreviewUrl(url: string): string {
	return url
}
